const mt_data = [
  { year: '2024', src: '/ActivityDetail-img/2024/MT/엠티2.jpeg' },
  { year: '2024', src: '/ActivityDetail-img/2024/MT/엠티1.jpeg' },
  { year: '2023', src: '/ActivityDetail-img/2023/MT/엠티3.jpg' },
  { year: '2023', src: '/ActivityDetail-img/2023/MT/엠티2.jpg' },
  { year: '2023', src: '/ActivityDetail-img/2023/MT/엠티1.jpg' },
];

export default mt_data;
